import { CloseButton as ChakraCloseButton } from '@chakra-ui/react';

type CloseButtonProps = React.ComponentProps<typeof ChakraCloseButton>;

const CloseButton = ({ ...props }: Readonly<CloseButtonProps>) => {
  return <ChakraCloseButton {...props} />;
};

export default CloseButton;
